import React from "react";

import type { Meta, StoryObj } from "@storybook/react";

import ScreenCard from "../../screens/ScreenCard";
import MarkdownView from "../../components/MarkdownView";
import Gap from "../../ui_atoms/Gap";
import { ListGroupItem, useListGroupRenderItem } from "../../components/ListGroup";

const CONTENT_MD = `
# Et eodem nardi petit

## Et iussa ad nymphae nihil sum effundit

Lorem markdownum quondam; ille ubi, edax adflatuque ceu, et nec, ore natum
Nesso, candida. Visus tuus totiens poenam scelus Sithonios telorum. Est [quod
recultae](http://veniunt.com/achilles-byblida) ego, est si sibi illa terga,
honore. Ferro valido crepuitque mergit et soceri pedes, in palmite distent
deficeret, perque. Inplicuit te ecquid **Phiale supremum** quod aram ipse amnem
Aiaci bipennifer voto mersurum, sit oppida ingentem Iovis Leucothoen Leucon.

1. Erubuisse Aglauros et furta Gigantas
2. Fallare minacia prospicit nostro
3. De quoque
4. Moratur his gravem tempora
5. Hortaturque Phoebeius tantus genua alter dives
6. Cum mediamque

Tamen prorumpit spemque Iovem tuta scit eadem, fata genus, circum. **Humo donis
hasta** magna illo, nec cum: una annis tantique
[quamvis](http://agmenmihi.com/venter-sceptri). Corniger dederunt libratum,
honores, est via hoc. Tumidis per arces solent Pindo! Captat hunc: superamur nec
vite iam, an consuetissima mirantur, [dea](http://repperit-mare.io/cum)?

var oem_subdirectory_forum = prebindingDial;
os += vle_character;
power = ctp_lossless_dial;

## Vates corpore

Sua mulces ametur populari sine, fractus, te curvamine descendunt letataque
mole, sententia est! Fugiebant mensum a quosque fassurae stirpe, et male populus
auras meque anhelitus erit carmina deprensa currum male Laertius tuas. Gutture
Paphius litus **ad ni admovit** annos ex sub nec haec, quoque, nam lumen, *ait*,
hinc. Gravis evocet, probetne rudibusque agris fraxinus aliquid, recepta. Evocat
orbem alti, ibat erat cuius [faciunt Abantiades
sata](http://sponte.org/rector.php) fluctus desine, ore.

        if (gif < 2) {
            ospfParity -= 431468 - 1 + process;
        } else {
            reality.spoofing_tween_market(defaultOutboxIct, truncateRamTransfer(-1,
                laptop, software_rootkit_olap));
            softGrepSwappable(pdfTweenHeat, 1, ad);
            ppp_export.saas(udp, computing, 647086);
        }
            if (file.real_san_clean(sample)) {
            active_eide(fpu_udp * 5, -4);
        } else {
            bootDriver = 2;
        }
            if (tutorialFddiIbm) {
            flowchart_rup_dma.rgbPath = icqHdvRdram;
            ip.barVideo -= 2;
        }
        if (services - spooling + thyristorWi(2, domain, snmp) < model) {
            active_core_read.bar = bcc_string_perl;
            netmask_volume -= vdslDll;
            mpeg += symbolic * vgaTooltip;
        }
        newbie += 7 - serviceCybercrimePcb - dataMulti;

Gerentem arbor, reccidimus ducentem freti: cognatumque fruge defuerunt
foribusque matre, violentior tubae et nomine laticemque infelix. Fuit quae, nova
ibi sulphura haberet velut quoque, obiecit dubiae. [Rubor
undique](http://www.vires.io/) abire **terreno**! Sit fugientis portus, maiores,
figuram quae; bracchia incepto.
`;
const StoryComponent = ({ error }: { error?: null | string }) => {
    const errors = error ? error.split("\n") : undefined;
    return (
        <ScreenCard
            title="ScreenCard title"
            buttons={[{ title: "This is a larger text that fit", onPress: () => {} }]}
            shrinkButtonToIcon="search"
            slideButtonUp
            headband={errors ? { mode: "error", text: errors } : undefined}
        >
            <MarkdownView markdown={CONTENT_MD} />
            <Gap gap={3} />
        </ScreenCard>
    );
};

const VIRTUALIZED_ITEMS: ListGroupItem<string>[] = Array.from({ length: 60 }, (_, index) => ({
    value: `${index}`,
    title: `Virtualized item ${index + 1}`,
    icon: "talent",
    useBigAvatarOrIcon: true,
    // Every third row is taller, so rows keep the heterogeneous heights that force
    // RecyclerListView's non-deterministic (measure-then-relayout) rendering path.
    description: index % 3 === 0 ? "A description that makes this row taller" : undefined,
}));

/** Exercises ScreenCard's opt-in virtualized body (`virtualizedItems` + `renderItem`). */
const VirtualizedStoryComponent = () => {
    const renderItem = useListGroupRenderItem(VIRTUALIZED_ITEMS, { isItemsCheckable: false });

    return (
        <ScreenCard
            title="Virtualized ScreenCard"
            virtualizedItems={VIRTUALIZED_ITEMS}
            renderItem={renderItem}
        />
    );
};

const meta = {
    title: "Components/ScreenCard",
    component: StoryComponent,
    argTypes: {
        error: { control: { type: "text" } },
    },
    args: {},
    decorators: [(StoryFn) => <StoryFn />],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        error: undefined,
    },
};

export const WithError: Story = {
    args: {
        error: "This is an error message\nAnd another line",
    },
};

export const Virtualized: Story = {
    args: {
        error: undefined,
    },
    render: () => <VirtualizedStoryComponent />,
};
